(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('magnaear-earrings-promo')) {
    customElements.define('magnaear-earrings-promo', class extends HTMLElement {
      connectedCallback() {
        // Keep native <details> semantics; animate only the existing promo panel.
        // This works in mobile Safari as well as desktop browsers.
        this.disclosure = this.querySelector('.magnaear-earrings-promo__disclosure');
        this.summary = this.querySelector('.magnaear-earrings-promo__summary');
        this.promoPanel = this.querySelector('.magnaear-earrings-promo__panel');
        this.promoInner = this.querySelector('.magnaear-earrings-promo__inner');
        this.promoExpanded = Boolean(this.disclosure?.open);
        if (this.disclosure) this.disclosure.dataset.promoExpanded = String(this.promoExpanded);
        this.onPromoClick = (event) => {
          // Summary click also supports Enter/Space activation and keyboard accessibility.
          event.preventDefault();
          this.togglePromo(!this.promoExpanded);
        };
        this.summary?.addEventListener('click', this.onPromoClick);
        this.onSectionChange = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.connectBanner());
        };
        document.addEventListener('shopify:section:load', this.onSectionChange);
        document.addEventListener('shopify:section:unload', this.onSectionChange);
        this.onSectionChange();
      }

      disconnectedCallback() {
        this.summary?.removeEventListener('click', this.onPromoClick);
        this.promoPanelAnimation?.cancel();
        this.promoInnerAnimation?.cancel();
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        document.removeEventListener('shopify:section:load', this.onSectionChange);
        document.removeEventListener('shopify:section:unload', this.onSectionChange);
      }

      togglePromo(expand) {
        const details = this.disclosure;
        const panel = this.promoPanel;
        if (!details || !panel) return;

        this.promoExpanded = expand;
        // Arrow reacts immediately, including while the panel is closing.
        details.dataset.promoExpanded = String(expand);

        const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion || typeof panel.animate !== 'function') {
          this.promoPanelAnimation?.cancel();
          this.promoInnerAnimation?.cancel();
          this.promoPanelAnimation = null;
          this.promoInnerAnimation = null;
          details.open = expand;
          panel.style.removeProperty('height');
          panel.style.removeProperty('padding-bottom');
          panel.style.removeProperty('overflow');
          return;
        }

        // Allow a rapid second tap to reverse the animation without a jump.
        const wasOpen = details.open;
        const panelStyle = getComputedStyle(panel);
        const startingHeight = wasOpen ? panel.getBoundingClientRect().height : 0;
        const startingOpacity = wasOpen ? panelStyle.opacity : '0.5';
        const startingPadding = wasOpen ? panelStyle.paddingBottom : '0px';
        const innerStyle = this.promoInner ? getComputedStyle(this.promoInner) : null;
        const startingInnerOpacity = wasOpen && innerStyle ? innerStyle.opacity : '0.75';
        const startingTransform = wasOpen && innerStyle ? innerStyle.transform : 'translateY(-5px)';

        this.promoPanelAnimation?.cancel();
        this.promoInnerAnimation?.cancel();
        this.promoPanelAnimation = null;
        this.promoInnerAnimation = null;
        details.open = true;
        panel.style.removeProperty('height');
        panel.style.removeProperty('padding-bottom');
        panel.style.removeProperty('overflow');
        const endingHeight = expand ? panel.getBoundingClientRect().height : 0;
        const endingPadding = expand ? getComputedStyle(panel).paddingBottom : '0px';
        panel.style.height = `${startingHeight}px`;
        panel.style.paddingBottom = startingPadding;
        panel.style.overflow = 'hidden';

        const timing = { duration: expand ? 420 : 360, easing: 'cubic-bezier(.4, 0, .2, 1)', fill: 'both' };
        const animation = panel.animate(
          [
            { height: `${startingHeight}px`, paddingBottom: startingPadding, opacity: startingOpacity },
            { height: `${endingHeight}px`, paddingBottom: endingPadding, opacity: expand ? 1 : 0.55 }
          ],
          timing
        );
        this.promoPanelAnimation = animation;
        if (this.promoInner?.animate) {
          this.promoInnerAnimation = this.promoInner.animate(
            [
              { opacity: startingInnerOpacity, transform: startingTransform },
              { opacity: expand ? 1 : 0.75, transform: expand ? 'translateY(0)' : 'translateY(-5px)' }
            ],
            timing
          );
        }
        animation.onfinish = () => {
          if (this.promoPanelAnimation !== animation) return;
          this.promoPanelAnimation = null;
          if (!this.promoExpanded) details.open = false;
          panel.style.removeProperty('height');
          panel.style.removeProperty('padding-bottom');
          panel.style.removeProperty('overflow');
          animation.cancel();
          this.promoInnerAnimation?.cancel();
          this.promoInnerAnimation = null;
        };
      }

      connectBanner() {
        this.observer?.disconnect();
        // Read the existing SLAE BANER display, including its shared cycle reset.
        this.source = document.querySelector('.promo-countdown promo-countdown-timer');
        this.sync();
        if (this.source) {
          this.observer = new MutationObserver(() => this.sync());
          this.observer.observe(this.source, { childList: true, subtree: true, characterData: true });
        }
      }

      sync() {
        const countdown = this.querySelector('[data-countdown]');
        const note = this.querySelector('[data-editor-note]');
        if (!countdown || !note) return;
        const parts = ['days', 'hours', 'minutes', 'seconds'];
        const values = parts.map(part => this.source?.querySelector(`[data-${part}]`)?.textContent.trim());
        const ready = values.every(value => /^\d+$/.test(value || ''));
        countdown.hidden = !ready;
        note.hidden = ready || this.dataset.editor !== 'true';
        note.textContent = ready ? '' : 'הטיימר יופיע כאשר הבאנר SLAE BANER פעיל בעמוד.';
        if (!ready) return;
        this.querySelector('[data-day-unit]').hidden = false;
        parts.forEach((part, index) => {
          const target = this.querySelector(`[data-${part}]`);
          if (target && target.textContent !== values[index]) {
            target.textContent = values[index];
            target.classList.remove('is-updating');
            // Restart the animation for the digits that actually changed.
            void target.offsetWidth;
            target.classList.add('is-updating');
          }
        });
        this.querySelector('[role="timer"]').setAttribute('aria-label',
          `${values[0]} ימים, ${values[1]} שעות, ${values[2]} דקות ו-${values[3]} שניות`);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
